import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { Store } from '@ngxs/store';
import { AccountState } from '@state/account/state';

@Directive({
  selector: '[appAccountColorBackground]',
  standalone: true,
  exportAs: 'appAccountColorBackground',
})
export class AccountColorBackgroundDirective {
  @Input() set colorName(val: string) {
    const colorHex =
      this.store.selectSnapshot(AccountState.selectAccountColorHexMap)[val] ?? this.defaultBackgroundColor;

    this.colorHex = colorHex;
    this.renderer2.setStyle(this.elRef.nativeElement, 'background-color', colorHex);
  }

  private colorHex: string;
  private readonly defaultBackgroundColor = '#F1F5F9';

  get isContrastLight(): boolean {
    if (typeof this.colorHex !== 'string' || this.colorHex.length < 7) return false;

    const r = parseInt(this.colorHex.slice(1, 3), 16);
    const g = parseInt(this.colorHex.slice(3, 5), 16);
    const b = parseInt(this.colorHex.slice(5, 7), 16);

    // The RGB values are converted to grayscale using the NTSC formula: 0.299 ∙ Red + 0.587 ∙ Green + 0.114 ∙ Blue.
    // This formula closely represents the average person's relative perception of the brightness of red, green, and blue light.
    // https://support.ptc.com/help/mathcad/r9.0/en/index.html#page/PTC_Mathcad_Help/example_grayscale_and_color_in_images.html
    const overallColorIntensity = r * 0.299 + g * 0.587 + b * 0.114;
    const intensityThreshold = 150;

    return overallColorIntensity < intensityThreshold;
  }

  constructor(
    private readonly store: Store,
    private readonly renderer2: Renderer2,
    private readonly elRef: ElementRef,
  ) {}
}
